// Import model
import { StartFpRoomCreateFileRequest } from '../models/StartFpRoomCreateFileRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartFpRoomCreateFileRequest - handles JSON serialization and deserialization with type validation
 */
export class StartFpRoomCreateFileRequestSerializer {
  /**
   * Deserializes a JSON string into a StartFpRoomCreateFileRequest instance
   */
  static deserialize(json: string): StartFpRoomCreateFileRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartFpRoomCreateFileRequest instance
   */
  static fromObject(obj: any): StartFpRoomCreateFileRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartFpRoomCreateFileRequest');
    }


    const instance: StartFpRoomCreateFileRequest = {
      contentType: obj['ContentType'] as string | undefined,
      name: obj['Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartFpRoomCreateFileRequest instances
   */
  static deserializeArray(json: string): StartFpRoomCreateFileRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartFpRoomCreateFileRequest instance to a JSON string
   */
  static serialize(instance: StartFpRoomCreateFileRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartFpRoomCreateFileRequest instance to a plain object
   */
  static toObject(instance: StartFpRoomCreateFileRequest): any {
    return {
      'ContentType': instance.contentType,
      'Name': instance.name,
    };
  }

  /**
   * Serializes an array of StartFpRoomCreateFileRequest instances to a JSON string
   */
  static serializeArray(instances: StartFpRoomCreateFileRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
